import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-common-arrow-vertical",
  "use": "icon-common-arrow-vertical-usage",
  "viewBox": "0 0 15 15",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 15 15\" fill=\"none\" id=\"icon-common-arrow-vertical\">\n  <path d=\"M3.31332 5.57422L7.25082 9.51172L11.1883 5.57422\" stroke-width=\"1.00189\" stroke-linecap=\"round\" stroke=\"currentColor\" stroke-linejoin=\"round\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol